export function idFromTabContents(params) {
    var _a, _b, _c;
    return [
        (_a = params.query) !== null && _a !== void 0 ? _a : '',
        (_b = params.variables) !== null && _b !== void 0 ? _b : '',
        (_c = params.headers) !== null && _c !== void 0 ? _c : '',
    ].join('|');
}
//# sourceMappingURL=id-from-tab-contents.js.map